module.exports = __webpack_public_path__ + "img/culturalAgent.31e93719.png";